import { service } from '@debatdirect/debatdirect-modules/core';
import { api } from '@debatdirect/debatdirect-modules/api';
import DownloadService from '@debatdirect/debatdirect-modules/services/DownloadService/DownloadService';
import PlatformService from '@debatdirect/debatdirect-modules/services/PlatformService/PlatformService';
import LiveDataService from '@debatdirect/debatdirect-modules/services/LiveDataService/LiveDataService';
import VideoService from '@debatdirect/debatdirect-modules/services/VideoService/VideoService';
import VideoSyncService from '@debatdirect/debatdirect-modules/services/VideoSyncService/VideoSyncService';
import ShareService from '@debatdirect/debatdirect-modules/services/ShareService/ShareService';
import PromptService from '@debatdirect/debatdirect-modules/services/PromptService/PromptService';
import AdditionsServiceFactory from '@debatdirect/debatdirect-modules/services/InteractionAdditionsService/AdditionsServiceFactory';
import DebugService from '@debatdirect/debatdirect-modules/services/DebugService/DebugService';
import DateService from '@debatdirect/debatdirect-modules/services/DateService/DateService';
import InfoPanelService from '@debatdirect/debatdirect-modules/services/InfoPanelService/InfoPanelService';
import RefreshService from '@debatdirect/debatdirect-modules/services/RefreshService/RefreshService';
import StatusService from '@debatdirect/debatdirect-modules/services/StatusService/StatusService';
import AuthService from '@debatdirect/debatdirect-modules/services/AuthService/AuthService';
import ElasticService from '@debatdirect/debatdirect-modules/services/ElasticService/ElasticService';
import UserPreferenceService from '@debatdirect/debatdirect-modules/services/UserPreferenceService/UserPreferenceService';
import NotificationsService from '@debatdirect/debatdirect-modules/services/NotificationsService/NotificationsService';

const
  { factory } = service,
  { Router }  = factory;

export default [
  {
    name   : 'api',
    factory: api,
    keyPath: [],
    props  : [
      { source: 'config', 'keyPath': ['api'] }
    ]
  },
  {
    name   : 'router',
    factory: Router,
    keyPath: [],
    props  : [
      { source: 'config', keyPath: ['routes'] }
    ]
  },
  {
    name   : 'video',
    factory: VideoService,
    keyPath: []
  },
  {
    name   : 'info-panel',
    factory: InfoPanelService,
    keyPath: ['ui', 'infoPanel']
  },
  {
    name   : 'debug',
    factory: DebugService,
    keyPath: []
  },
  {
    name   : 'live',
    factory: LiveDataService,
    keyPath: [],
    props  : [
      { source: 'config', keyPath: ['liveApi'] }
    ]
  },
  {
    name   : 'platform',
    factory: PlatformService,
    keyPath: []
  },
  {
    name   : 'prompt',
    factory: PromptService,
    keyPath: ['ui', 'prompt']
  },
  {
    name   : 'refresh',
    factory: RefreshService,
    keyPath: ['data']
  },
  {
    name   : 'interaction-additions',
    factory: AdditionsServiceFactory,
    keyPath: [],
    props  : [
      { source: 'config', keyPath: [] }
    ]
  },
  {
    name   : 'date',
    factory: DateService,
    keyPath: [],
    props  : [
      { source: 'config', keyPath: ['date'] }
    ]
  },
  {
    name   : 'share',
    factory: ShareService,
    keyPath: [],
    props  : [
      { source: 'config', keyPath: [] }
    ]
  },
  {
    name   : 'video-sync',
    factory: VideoSyncService,
    keyPath: []
  },
  {
    name   : 'status',
    factory: StatusService,
    keyPath: [],
    props: [
      { source: 'config', keyPath: ['status'] }
    ]
  },
  {
    name   : 'auth',
    factory: AuthService,
    keyPath: ['auth'],
    props: [
      { source: 'config', keyPath: ['auth'] }
    ]
  },
  {
    name   : 'download',
    factory: DownloadService,
    keyPath: ['ui', 'downloads'],
    props: [
      { source: 'config', keyPath: ['fragments'] }
    ],
  },
  {
    name   : 'search',
    factory: ElasticService,
    keyPath: [],
    props: [
      { source: 'config', keyPath: ['search'] }
    ],
  },
  {
    name   : 'preference',
    factory: UserPreferenceService,
    keyPath: ['ui', 'preference'],
    props: [],
  },
  {
    name   : 'notifications',
    factory: NotificationsService,
    keyPath: [],
    props: [],
  }
];



// WEBPACK FOOTER //
// ./src/services.js